import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CaseFunctions } from 'app/details-new/caseFunctions';
import * as api from '../../shared/api/apihandler';
import { Offer } from '../details/offer';
import { CaseDetails, OfferList } from 'app/details-new/details-new.data';
import { ClearPriceBasketInfo, OrderHistory, OrderHistoryLines } from './klarpris-purchase.data';
import { CalculationAssistant } from 'app/shared/utilities/calculationAssist';

@Component({
  selector: 'app-klarpris-purchases',
  templateUrl: './klarpris-purchases.component.html',
  styleUrls: ['./klarpris-purchases.component.css']
})
export class KlarprisPurchasesComponent implements OnInit {

  @Input() case: CaseDetails;

  caseActions = new CaseFunctions(this.http);
  unitData: any;
  offerList: OfferList[];
  productsToOrder: Array<any> = [];
  clearPriceDocuments: string[] = [];
  clearPriceStep = 0;
  clearPriceBasket = [];
  clearPriceBasketInfo = new ClearPriceBasketInfo();
  orderHistory: Array<OrderHistory>;
  orderHistoryLines: Array<OrderHistoryLines>;
  selectedOrder = new OrderHistory();
  orderHistoryGotten: boolean = false;
  calc = new CalculationAssistant();

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.getOrderHistory();
    this.checkIfPackageAndOffer();
  }

  getOrderHistory() {
    this.caseActions.getOrderHistory(this.case.caseId).subscribe({ 
      next: (data) => {
        this.orderHistory = data.sort((a: any, b: any) => a.orderDate > b.orderDate ? -1 : 1);
      },
      error: err => console.error(err),
      complete: () => {
        this.orderHistoryGotten = true;
        if (!!this.orderHistory) {
          for (let x of this.orderHistory) {
            x.orderDate = x.orderDate.split('+')[0];
          }
        }
        //console.log(this.orderHistory)
      }
    });
  }

  showOrder(id: number) {
    this.orderHistoryLines = [];
    this.selectedOrder = this.orderHistory.find(x => x.id == id);
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Website/KlarPris/GetKpHistoryProducts/' + id, { headers }).subscribe(
      (data: Array<OrderHistoryLines>) => {
        this.orderHistoryLines = data;
      },
      err => console.error(err),
      () => { }
    );
  }

  checkIfPackageAndOffer() {
    if (this.case.offerList.length > 0) {
      for (let x of this.case.offerList) {

      }
    }

    this.caseActions.getCaseProperties(this.route.snapshot.paramMap.get('id')).subscribe({
      next: (data: any[]) => {
        if (!!data && !!data.find(x => x.propertyId == '2e817829-f3e8-4e91-ba99-8c36136eafee')) {
          this.getPackageData(data.find(x => x.propertyId == '2e817829-f3e8-4e91-ba99-8c36136eafee').value);
        }
      }
    });
  }

  getPackageData(unitId) {
    this.caseActions.getUnit(unitId).subscribe({ next: (data) => { this.unitData = data; console.log(this.unitData); } });
  }

  async autoSetDeliveryToClearPriceBasketInfo() {
    //this.clearPriceBasketInfo = new ClearPriceBasketInfo();
    this.clearPriceBasketInfo.orderNumber = !!this.case.caseNumber ? this.case.caseNumber : !!this.case.externalId ? this.case.externalId : '';
    let d = this.case.deliveryAddress;
    let c = this.case.customer;
    if (d.id != null) {
      this.clearPriceBasketInfo.name = d.name;
      this.clearPriceBasketInfo.address = d.address;
      this.clearPriceBasketInfo.zipCode = d.zipCode;
      this.clearPriceBasketInfo.city = d.city;
    }
    else {
      this.clearPriceBasketInfo.name = c.name;
      this.clearPriceBasketInfo.address = c.address;
      this.clearPriceBasketInfo.zipCode = c.zipCode;
      this.clearPriceBasketInfo.city = c.city;
    }

    if (this.case.offerList.length > 0) {
    } else if (!!this.unitData) {
      for (let x of this.unitData.productLines) {
        this.productsToOrder.push({
          "productId": x.productNumber,
          "wholesaler": x.wholeSaler.toString(),
          "quantity": x.quantity.toString()
        });
      }
      this.clearPriceBasketInfo.products = this.productsToOrder;
    } else {
      console.log('no offers or package on case');
    }
    
  }

  docToClearPrice(id) {
    if (this.clearPriceDocuments.includes(id)) {
      this.clearPriceDocuments = this.clearPriceDocuments.filter(x => x != id);
    } else {
      this.clearPriceDocuments.push(id);
    }
  }

  async addToClearPriceBasket(id: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {

      if (this.productsToOrder.length > 0) {
        this.clearPriceBasketInfo.products = this.productsToOrder;
        resolve();
      } else {
        if (this.clearPriceBasket.includes(id)) {
          this.clearPriceBasket.splice(this.clearPriceBasket.indexOf(id), 1);
          this.clearPriceBasketInfo.products = this.clearPriceBasketInfo.products.filter(x => x.offerId != id);
          resolve();
        } else {
          this.clearPriceBasket.push(id);
          const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
          this.http.get<Offer>(api.jubloApi + 'api/Website/Offer/' + id, { headers }).subscribe({
            next: (data) => {
              let a = data.productLines.filter(y => !!y.wholeSaler && +y.wholeSaler < 99).map(x => {
                return {
                  offerId: id,
                  productId: x.productNumber,
                  wholesaler: x.wholeSaler,
                  quantity: x.quantity.toString()
                }
              });
              this.clearPriceBasketInfo.products = this.clearPriceBasketInfo.products.concat(a);
              resolve(); // Markerer, at GET-anmodningen er fuldført
            },
            error: err => {
              console.error(err);
              reject(err); // Markerer, at GET-anmodningen er mislykket
            }
          });
        }
      }
    });
  }

  async addToBasket() {
    let fetchPromises: Promise<void>[] = [];

    for (let id of this.clearPriceDocuments) {
      let fetchPromise = this.addToClearPriceBasket(id);
      fetchPromises.push(fetchPromise);
    }

    try {
      // Vent på, at alle GET-anmodninger er færdige
      await Promise.all(fetchPromises);
      const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('bearer') });
      this.http.post(api.jubloApi + 'api/Website/OfferProductSearch/ClearPriceBasket', this.clearPriceBasketInfo, { headers, responseType: 'text' as 'json' }).subscribe({
        next: (val: any) => {
          let encodedString = encodeURIComponent(val).toString();
          this.router.navigate(['/Shop'], { queryParams: { basket: encodedString } });
        },
        error: err => console.error(err)
      });
    } catch (error) {
      console.error('Fejl under hentning af data:', error);
    }
  }

  statusByGuid(id) {
    if (!!id) {
      switch (id.toLowerCase()) {
        case ('bee21fe3-503e-4a8b-8ac4-030929c87741'): {
          return { text: 'Offers.AwaitingAccept', color: 'badge-info' }
        }
        case ('e65f9d9e-34b2-4423-8ad4-7228db8814b4'): {
          return { text: 'Offers.Rejected', color: 'badge-danger' }
        }
        case ('a1a453b8-6ae7-453d-bfdb-867ace78654e'): {
          return { text: 'Offers.Accepted', color: 'badge-success' }
        }
        case ('f833a8c3-2944-4a3d-a9b3-8faa01156485'): {
          return { text: 'Offers.New', color: 'badge-warning' }
        }
        case ('dc604f52-769c-4568-88f5-b77ff41ad95e'):
        case ('e958c326-863b-4545-bf13-bb6df821f2fd'): {
          return { text: 'Offers.AwaitingReply', color: 'badge-info' }
        }
        case ('8bfc347c-40c4-42ca-93fc-f4d651c0a109'): {
          return { text: 'Offers.Pipeline', color: 'badge-light' }
        }
        default: {
          return { text: 'Offers.Other', color: 'badge-warning' }
        }
      }
    } else {
      return { text: 'Offers.New', color: 'badge-warning' };
    }
  }
}

